import { createFileRoute } from "@tanstack/react-router";

import AccountsOverview from "@/components/Loyalty/AccountsOverview";

export const Route = createFileRoute("/gym/$venueUuid/loyalty/accounts")({
  component: AccountsOverview,
});
